import { snakeCase } from 'lodash'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { AddressField } from '../../types'

export default function useRequiredAddressField() {
  const translate = useTranslate()

  return function requiredField(field: AddressField) {
    const fieldName = translate(
      `kyc_form.business.ubo.address.modal.fields.${snakeCase(field)}.title`,
    )

    return {
      value: true,
      message: translate('errors.blank', { field: fieldName }),
    }
  }
}
